<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="machineCategory"
        [pageName]="pageName"
        [machineId]="machineId"
        [pageType]="pageType">

    </scitis-page-header-logo-and-name>
  </div>
  <ng-template #filterElement>
    <ng-template #framePageHelp>
      <div class="p-2">
        <span [innerHtml]="framePageHelpText"></span>&nbsp;<a
          href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Frame-Options" target="_blank" translate>Learn
        more</a>
      </div>
    </ng-template>
    <button class="btn btn-secondary" placement="bottom-right" container="body" [ngbTooltip]="framePageHelp"
            triggers="click:blur">
      <span class="fa-solid fa-circle-question"></span>
      <span translate>Help</span>
    </button>
  </ng-template>

</scitis-app-global-page-header>
<div class="page-content">
  <scitis-frame-page
      [embeddedContentUrl]="embeddedContendUrl"
      [pageName]="pageName">
  </scitis-frame-page>
</div>
